import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Wrench } from "lucide-react";

const KomikNaEvent = () => (
  <SeoPageLayout title="Komik" titleAccent="na event">
    <SeoSection title="Profesjonalny komik na Twój event">
      <p>Szukasz oryginalnego urozmaicenia swojego eventu? Profesjonalny komik to gwarancja dobrej zabawy i niezapomnianych wrażeń. Niezależnie od tego, czy organizujesz konferencję, galę, imprezę firmową czy prywatne przyjęcie - występ komediowy nada Twojemu wydarzeniu wyjątkowy charakter.</p>
    </SeoSection>

    <SeoSection title="Rodzaje eventów, na których występujemy">
      <SeoStyledList items={[
        "Eventy korporacyjne - konferencje, seminaria, szkolenia",
        "Imprezy integracyjne - team building, wyjazdy firmowe",
        "Gale i bankiety - ceremonie wręczenia nagród, jubileusze",
        "Eventy branżowe - targi, dni otwarte, launch produktu",
        "Imprezy okolicznościowe - wigilie, imprezy karnawałowe, pikniki firmowe",
        "Eventy prywatne - urodziny, rocznice, przyjęcia"
      ]} />
    </SeoSection>

    <SeoSection title="Co wyróżnia naszych komików?">
      <p>Nasi komicy to doświadczeni profesjonaliści, którzy regularnie występują na scenach stand-upowych w całej Polsce. Każdy z nich ma za sobą setki występów przed różnorodną publicznością. Potrafią dopasować styl humoru do charakteru wydarzenia, czytać nastroje publiczności i improwizować w czasie rzeczywistym.</p>
    </SeoSection>

    <SeoSection title="Jak zamówić komika na event?">
      <SeoNumberedSteps steps={[
        { title: "Kontakt", description: "Wypełnij formularz kontaktowy lub zadzwoń do nas." },
        { title: "Ustalenie szczegółów", description: "Ustalimy szczegóły wydarzenia i dobierzemy odpowiedniego komika." },
        { title: "Spersonalizowana oferta", description: "Przygotujemy spersonalizowaną ofertę dopasowaną do Twoich potrzeb." },
        { title: "Występ", description: "Od pierwszego kontaktu do występu - zajmujemy się wszystkim, byś mógł skupić się na organizacji reszty eventu." },
      ]} />
    </SeoSection>

    <SeoSection title="Obsługa techniczna występu">
      <p>Zapewniamy pełne wsparcie techniczne. Komik przyjeżdża z własnym mikrofonem i może dostosować się do warunków technicznych Twojego lokalu. W razie potrzeby pomagamy w organizacji nagłośnienia i oświetlenia, by występ wypadł perfekcyjnie.</p>
      <SeoHighlightBox icon={Wrench}>
        Zapewniamy komplet sprzętu: mikrofon bezprzewodowy, nagłośnienie i oświetlenie sceniczne - bez dodatkowych kosztów.
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaEvent;
